import axios from "axios";

const endpoint_url = "/message/messageBlasting/list";

const getMessageList = (parameters) => {
  return new Promise((resolve, reject) => {
    axios
      .get(endpoint_url, { params: parameters })
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default getMessageList;
